import { observer } from 'mobx-react-lite'
import React from 'react'
import { IAccount, paths } from 'shopify-payment-core'

import { LoaderSpinner } from '../atoms/LoaderSpinner'
import { useFirebaseQuery } from '../hooks/useFirebaseQuery'
import { AccountNotFound } from '../molecules/AccountNotFound'
import { AccountControl } from '../organisms/AccountControl'
import { MainLayout } from '../organisms/MainLayout'

interface IProps {
  accountId: ID
}

export const AccountPage = observer<IProps>(({ accountId }) => {
  const { data: account, loading } = useFirebaseQuery<IAccount>(
    paths.gopay.getAccount(accountId),
    { subscribe: true },
  )

  let render

  if (loading) {
    render = <LoaderSpinner />
  } else if (account) {
    render = <AccountControl account={account} />
  } else {
    render = <AccountNotFound />
  }

  return <MainLayout>{render}</MainLayout>
})
